import Vue from 'vue';

var options = {
  persist: true,
};
Vue.use(options);

const state = {
  fieldsArr: [],
  loadedFieldsArr: [],
};
const getters = {
  getApiLoad_82: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  SET_NewField: function (state, newField) {
    const transformedField = {
      [`${newField.fieldName}${newField.level}`]: newField.value,
      level: newField.level,
    };
    const filteredArray = state.fieldsArr?.filter((item) => item.level < transformedField.level);
    state.fieldsArr = [...filteredArray, transformedField];
  },
  SET_LoadedData: function (state, data) {
    state.loadedFieldsArr = data;
  },

  CLEAR_LoadedData: function (state) {
    state.loadedFieldsArr = [];
  },
  CLEAR_FieldsArr: function (state) {
    state.fieldsArr = [];
  },
};
const actions = {
  setNewFieldDispatch({ commit }, { value, level, fieldName }) {
    const newField = {
      value,
      level,
      fieldName,
    };
    commit('SET_NewField', newField);
  },
  setWholeDataDispatch({ commit }, data) {
    commit('SET_LoadedData', data);
  },
  // popWholeDataDispatch({ commit }) {},
  clearLoadedDataDispatch({ commit }) {
    commit('CLEAR_LoadedData');
  },
  clearFieldsArrDispatch({ commit }) {
    commit('CLEAR_FieldsArr');
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
